<template>
  <div>

    <car-type-selector v-model="selection"></car-type-selector>
    <header v-if="selection" class='lib__form__main__header'>
      <h2 class="lib__h2">{{ $t('e-mobility.car-specification-step.batteryCapacityTitle') }}
        <div class="lib__tooltips">
          <span @click="onBatteryModalClick">
            <i class="fas fa-info-circle lib__clickable-tooltips"></i>
          </span>
        </div>
      </h2>
    </header>
    <battery-capacity-form :carType="selection" v-model="batteryCapacity" v-if="selection"></battery-capacity-form>

    <ModalDialog :closeable="$t('common.close')" :open.sync="isBatteryModalOpen" size="default">
      <div>
        <p>{{ $t('e-mobility.car-specification-step.infoModelTypeModal') }}</p>
        <table class="lib__table">
          <thead>
            <tr>
              <th>{{ $t('e-mobility.car-specification-step.table.HeaderType') }}</th>
              <th>{{ $t('e-mobility.car-specification-step.table.AverageHeader') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-table-header="type-header">
                {{ $t('e-mobility.car-specification-step.table.cell1') }}
                <br />
                <span class="lib__text-small">{{ $t('e-mobility.car-specification-step.table.carType.hybrid') }}</span>
              </td>
              <td data-table-header="average-header">{{ $t('e-mobility.car-specification-step.table.cell2') }}</td>
            </tr>
            <tr>
              <td data-table-header="type-header">
                {{ $t('e-mobility.car-specification-step.table.cell3') }}
                <br />
                <span class="lib__text-small">{{ $t('e-mobility.car-specification-step.table.carType.electric') }}</span>
              </td>
              <td data-table-header="average-header">
                {{ $t('e-mobility.car-specification-step.table.cell4') }}
                <br />
                <span class="lib__text-small">{{ $t('e-mobility.car-specification-step.table.cell4Description') }}</span>
              </td>
            </tr>
            <tr>
              <td data-table-header="type-header">
                {{ $t('e-mobility.car-specification-step.table.cell5') }}
                <br />
                <span class="lib__text-small">{{ $t('e-mobility.car-specification-step.table.carType.electric') }}</span>
              </td>
              <td data-table-header="average-header">
                {{ $t('e-mobility.car-specification-step.table.cell6') }}
                <br />
                <span class="lib__text-small">{{ $t('e-mobility.car-specification-step.table.cell6Description') }}</span>
              </td>
            </tr>
            <tr>
              <td data-table-header="type-header">
                {{ $t('e-mobility.car-specification-step.table.cell7') }}
                <br />
                <span class="lib__text-small">{{ $t('e-mobility.car-specification-step.table.carType.electric') }}</span>
              </td>
              <td data-table-header="average-header">
                {{ $t('e-mobility.car-specification-step.table.cell8') }}
                <br />
                <span class="lib__text-small">{{ $t('e-mobility.car-specification-step.table.cell8Description') }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-html="$t('e-mobility.car-specification-step.infoBatteryLink')"></p>
        <a class="lib__text-secondary" @click="trackClick" target="_blank" href="https://www.automobile-propre.com/voitures/"><b>https://www.automobile-propre.com/voitures/</b></a>
      </div>
    </ModalDialog>
  </div>
</template>

<script lang="ts">
import BatteryCapacityForm from '@/components/inputs/EMobility/Car/BatteryCapacityForm.vue'
import CarTypeSelector from '@/components/inputs/EMobility/Car/CarTypeSelector.vue'
import { CarSpecification, CarType } from '@/models'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component({
  components: {
    CarTypeSelector,
    BatteryCapacityForm
  },
  name: 'car-specification-selector'
})
export default class CarSpecificationSelector extends Vue {
  //#region [Property]
  @Prop({ type: Object }) public readonly value!: CarSpecification | null
  @Prop({ type: Boolean, required: true }) public readonly required!: boolean
  //#endregion

  //#region [Data]
  @State('requestId', { namespace: 'eMobility' })
  public requestId!: string

  public isBatteryModalOpen: boolean = false
  //#endregion

  //#region [Computed]
  public get selection(): CarType | null {
    return this.value?.carType || null
  }

  public set selection(val: CarType | null) {
    this.$emit('input', Object.assign({}, this.value, { carType: val }))
  }

  public get batteryCapacity(): number | null {
    return this.value?.batteryCapacity || null
  }

  public set batteryCapacity(val: number | null) {
    this.$emit('input', Object.assign({}, this.value, { batteryCapacity: val }))
  }
  //#endregion

  //region [Method]
  public onBatteryModalClick(): void {
    this.$appInsights.trackEvent('EMobility_TooltipClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Tooltip: 'BatteryCapacity'
    })
    this.isBatteryModalOpen = !this.isBatteryModalOpen
  }

  public trackClick(): void {
    this.$appInsights.trackEvent('EMobility_linkClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Link: 'AutomobilePropre'
    })
  }

  //#endregion
}
</script>